import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import {
  CurrentNetworkProvider,
  CurrentSessionProvider,
  CurrentUrlProvider,
  CurrentUserProvider,
  getCurrentUrl,
} from 'hb-react/frontoffice/contexts/DefaultAppContexts';
import CombineProvider from 'hb-react/shared/components/CombineProvider';
import QueryClientProvider from 'hb-react/shared/providers/QueryClient';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const App = ({
  children,
  colors,
  network,
  networkId,
  providers,
  session,
  theme,
  theming,
  user,
}) => {
  const allProviders = useMemo(
    () =>
      [
        {
          provider: QueryClientProvider,
        },
        (!isEmpty(network) || networkId) && {
          provider: CurrentNetworkProvider,
          currentNetwork: network,
          currentNetworkId: networkId,
        },
        user && {
          provider: CurrentUserProvider,
          currentUser: user,
        },
        session && {
          provider: CurrentSessionProvider,
          currentSession: session,
        },
        {
          provider: CurrentUrlProvider,
          currentUrl: getCurrentUrl(),
        },
        {
          provider: ThemeProvider,
          theme,
          options: {
            customNetworkColors: colors ?? network?.colors ?? {},
            customNetworkTheming: theming ??
              network?.theming ?? { po: {}, fo: {}, global: {} },
          },
        },
        ...providers,
      ].filter(Boolean),
    [network, networkId, user, session, theme, colors, theming, providers],
  );

  return <CombineProvider providers={allProviders}>{children}</CombineProvider>;
};

App.propTypes = {
  theme: PropTypes.oneOf(['po', 'fo', 'bo']).isRequired,
  colors: PropTypes.object,
  network: PropTypes.object,
  user: PropTypes.object,
  providers: PropTypes.array,
  children: PropTypes.node.isRequired, // For typescript
};

App.defaultProps = {
  providers: [],
};

export default App;
